import React from "react";
import { useFormikContext } from "formik";
//#region types
import { ProjectMemberBillingDetailsFieldProps } from "models/propTypes/timeReportingProjectPropTypes";
import { TimeReportingProjectFormTypes } from "models/formTypes";
//#endregion
//#region components
import BillingDetailsField from "./billingDetailsField";
//#endregion
import { FormHelper } from "utils/helpers";
import { FormFieldConstants } from "utils/constants";

const MemberBillingDetailsField: React.FC<ProjectMemberBillingDetailsFieldProps> = (props) => {
  const { values } = useFormikContext<any>();
  const fieldInfo = FormHelper.getTableRowFieldInfo(props.name ?? "");

  const members = fieldInfo?.fieldName
    ? (values[fieldInfo?.fieldName] as TimeReportingProjectFormTypes.ExtendedProjectMember[])
    : undefined;

  const member = members?.find((_, index) => index === fieldInfo?.rowIndex);

  return (
    <BillingDetailsField
      text={member?.name}
      individualBillingModel={member?.individualBillingModel}
      hourlyRate={member?.hourlyRate}
      hours={member?.hours}
      currency={props.currency}
      currentRate={member?.currentRate}
      showCurrentRate={
        fieldInfo?.fieldName === FormFieldConstants.TimeReportingProject.ProjectCategory.FutureMemberRates
      }
    ></BillingDetailsField>
  );
};

export default MemberBillingDetailsField;
